import styled from '@emotion/styled';

const selectedColor = '#ebebeb';

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const DropdownFilterStyled = styled.button`
  position: relative;
  width: 175px;
  height: 28px;
  padding: 0.21rem 1.07rem;
  overflow-y: visible;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  background: ${({ isOpen }) => (isOpen ? selectedColor : '#fff')};
  box-shadow: ${({ isOpen }) =>
    isOpen ? 'inset 0 3px 5px rgba(0, 0, 0, 0.125)' : 'none'};

  div {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.default};
  }

  &:hover {
    background: ${selectedColor};
  }
`;

export const CaretIcon = styled.b`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.28rem;
  border-top: 0.28rem solid;
  border-right: 0.28rem solid transparent;
  border-left: 0.28rem solid transparent;
`;

export const Menu = styled.div`
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(100%);
  background: #fff;
  border: 1px solid #c0c0c0;
  z-index: 1000;
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.15);
`;

export const FilterWrapper = styled.div`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  margin: 0.35rem;
  display: flex;

  input {
    height: 34px;
    width: 80%;

    &::placeholder {
      font-size: 1rem;
    }
  }
`;

export const ClearFilterButton = styled.button`
  width: 20%;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ccc;
  border-left: none;

  &:hover {
    background: #ebebeb;
  }
`;

export const Options = styled.div`
  max-height: 30rem;
  overflow: auto;
`;

export const Option = styled.div`
  cursor: pointer;
  color: ${({ selected, theme }) =>
    selected ? theme.colors.textLight : theme.colors.textDark};
  background: ${({ selected }) => (selected ? '#428bca' : 'none')};
  display: flex;
  align-items: center;

  input {
    margin: 0.35rem 0.57rem 0.35rem 0.35rem;
  }
`;
